import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { AppLayout, ProtectedRoute } from './components/layout/AppLayout';
import ConsentBanner from './components/common/ConsentBanner';
import { LoginPage, RegisterPage, ForgotPasswordPage, ResetPasswordPage } from './components/auth/AuthPages';
import DashboardPage from './pages/DashboardPage';
import PropertyDetailPage from './pages/PropertyDetailPage';
import MarketplacePage from './pages/MarketplacePage';
import BookingsPage from './pages/BookingsPage';
import ProProfilePage from './pages/ProProfilePage';
import EOIMarketplacePage from './pages/EOIMarketplacePage';
import PortfolioPage from './pages/PortfolioPage';
import ProjectsPage from './pages/ProjectsPage';
import ProjectDetailPage from './pages/ProjectDetailPage';
import MarketInsightsPage from './pages/MarketInsightsPage';
import AdminDashboardPage from './pages/AdminDashboardPage';
import ProDashboardPage from './pages/ProDashboardPage';
import AdminRegisterPage from './pages/AdminRegisterPage';
import AdminVerifyEmailPage from './pages/AdminVerifyEmailPage';
import AdminDecidePage from './pages/AdminDecidePage';
import MFAEnrollPage from './pages/MFAEnrollPage';
import SettingsPage from './pages/SettingsPage';
import NotificationsPage from './pages/NotificationsPage';
import TransfersPage from './pages/TransfersPage';

export default function App() {
  return (
    <AuthProvider>
      <ConsentBanner />
      <BrowserRouter>
        <Routes>
          {/* Public */}
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/admin-register" element={<AdminRegisterPage />} />
          <Route path="/admin/verify-email" element={<AdminVerifyEmailPage />} />
          <Route path="/admin/decide" element={<AdminDecidePage />} />
          <Route path="/mfa/enroll" element={<MFAEnrollPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route path="/reset-password" element={<ResetPasswordPage />} />

          {/* Protected */}
          <Route element={<ProtectedRoute />}>
            <Route element={<AppLayout />}>
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/properties/:id" element={<PropertyDetailPage />} />
              <Route path="/marketplace" element={<MarketplacePage />} />
              <Route path="/bookings" element={<BookingsPage />} />
              <Route path="/pros/:id" element={<ProProfilePage />} />
              <Route path="/pro/profile" element={<ProProfilePage />} />
              <Route path="/pro" element={<ProDashboardPage />} />
              <Route path="/eoi" element={<EOIMarketplacePage />} />
              <Route path="/portfolio" element={<PortfolioPage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/projects/:id" element={<ProjectDetailPage />} />
              <Route path="/insights" element={<MarketInsightsPage />} />
              <Route path="/settings" element={<SettingsPage />} />
              <Route path="/notifications" element={<NotificationsPage />} />
              <Route path="/transfers" element={<TransfersPage />} />
              <Route path="/transfers/:id" element={<TransfersPage />} />
            </Route>
          </Route>

          {/* Admin — restricted to admin role */}
          <Route element={<ProtectedRoute allowedRoles={['admin']} />}>
            <Route element={<AppLayout />}>
              <Route path="/admin" element={<AdminDashboardPage />} />
            </Route>
          </Route>

          {/* Legacy redirect — /redbook now lives under each property */}
          <Route path="/redbook" element={<Navigate to="/dashboard" replace />} />

          {/* Catch-all */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
